<template>
  <section v-if="data.descriptions.length">
    <DiagonalDescriptions :descriptions="data.descriptions"/>
  </section>
</template>

<style scoped>

</style>

<script>

import DiagonalDescriptions from "@/components/organisms/DiagonalDescriptions.vue";

export default {
  props: {
    data: Object
  },
  components: {DiagonalDescriptions}

}
</script>
